// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Uvn5u","image":"styles_image__qiRou"};